import React from 'react';
import './UserReplyRow.css';

export interface UserReplyRowProps {
  displayText: string;
  showUndo: boolean;
  onUndo: () => void;
  undoLabel: string;
  /** When the full form thread is complete (review mode), show next to the bubble. */
  showEdit?: boolean;
  onEdit?: () => void;
  editLabel?: string;
}

const UserReplyRow: React.FC<UserReplyRowProps> = ({
  displayText,
  showUndo,
  onUndo,
  undoLabel,
  showEdit = false,
  onEdit,
  editLabel = '',
}) => {
  return (
    <div className="wr-user-row">
      <div className="wr-user-row__bubble-wrap">
        <div className="wr-user-row__bubble">
          <div className="wr-user-row__lines">
            <div>{displayText}</div>
          </div>
        </div>
        {(showEdit || showUndo) && (
          <div className="wr-user-row__actions">
            {showEdit && onEdit ? (
              <button type="button" className="wr-user-row__edit" onClick={onEdit}>
                {editLabel}
              </button>
            ) : null}
            {showUndo ? (
              <button type="button" className="wr-user-row__undo" onClick={onUndo}>
                {undoLabel}
              </button>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserReplyRow;
